<template>
    <div class="app" >
        <auth :config="authConfig">
            <div style='height:50px;border-bottom:1px solid lightgrey;'>
                <btn i='bars' @press='foldSidebar'/>
                <img :src="authConfig.logo"  style="vertical-align:middle;height:40px;margin:5px;"/>
                <span style='vertical-align:middle;'>IWEP ADMIN PANEL</span>
            </div>
            <i-sidebar :config="sidebarConfig">
                <router-view/>
            </i-sidebar>
            <i-wysiwyg-service/>
        </auth>
    </div>
</template>
<script>

import iSidebar from "../../components/desktop/i-sidebar.vue";
import Auth from "../../components/desktop/auth.vue";
import routes from "./routes.js";
export default {
    name: "app",
    components:{iSidebar,Auth},
    props: [],
    methods:{

        foldSidebar(){
            _i.bus.$emit('fold-sidebar');
        }
    },
    beforeUpdate(){
        if(this.$router.currentRoute.path === '/exit'){
            this.$store.dispatch('signOut');   
        }
    },
    data(){
        return {
                authConfig:{
                    logo: require('./assets/img/logo_black.png'),
                    background: require('./assets/img/wallpaper.jpg'),
                    signup:!true,
                    password_reset:!true,
                    fast_signin:!true,
                    labels:{
                        login: 'Телефон', 
                        password: 'Пароль'
                    }
            },
            sidebarConfig:{
                items:routes,
                width:160
                /*[{
                    label:'Пользователи',
                    path:'/users',
                    icon:'user'
                },{
                    label:'Счета',
                    path:'/payments',
                    icon:'credit-card'
                },{
                    label:'Домены',
                    path:'/domains',
                    icon:'globe'

                },{
                    label:'Тутор',
                    path:'/tutor',
                    icon:'book'

                }]*/
            }
        }
    }
}
</script>
<style >
img[data-mce-src]{
    margin:10px 20px;
}
@import url('https://fonts.googleapis.com/css?family=Open+Sans');

.mce-notification-warning {display:none!important;}
*{
    font-family: 'Open Sans', sans-serif;
}

.app{
    min-height: 100%;
}
h2{
    margin:6px 0 ;
}
.padded{
    padding:6px 12px;
}
</style>